import { put, call, fork, take } from 'redux-saga/effects';
import { REQUEST } from 'redux-config/reduxHelpers';
import { acceptError } from 'common/_redux';

import * as api from '../api';
import * as ActionTypes from './actions';

export function* getCrmClientsAnalyticsSaga({ search }) {
  try {
    const { status, data } = yield call(api.getCrmClientsAnalytics, search);
    if (status < 300) {
      yield put(ActionTypes.getCrmClientsAnalytics.success({ ...data }));
    } else {
      yield put(acceptError(data.detail, true));
      yield put(ActionTypes.getCrmClientsAnalytics.failure());
    }
  } catch (e) {
    yield put(acceptError(e, true));
    yield put(ActionTypes.getCrmClientsAnalytics.failure());
  }
}
export function* getCrmClientsAnalyticsWatcherSaga() {
  while (true) {
    const { search } = yield take(ActionTypes.GET_CRM_CLIENTS_ANALYTICS[REQUEST]);
    yield call(getCrmClientsAnalyticsSaga, search);
  }
}

export function* getCrmManagersAnalyticsSaga({ search }) {
  try {
    const { status, data } = yield call(api.getCrmManagersAnalytics, search);
    if (status < 300) {
      yield put(ActionTypes.getCrmManagersAnalytics.success(data));
    } else {
      yield put(acceptError(data.detail, true));
      yield put(ActionTypes.getCrmManagersAnalytics.failure());
    }
  } catch (e) {
    yield put(acceptError(e, true));
    yield put(ActionTypes.getCrmManagersAnalytics.failure());
  }
}
export function* getCrmManagersAnalyticsWatcherSaga() {
  while (true) {
    const { search } = yield take(ActionTypes.GET_CRM_MANAGERS_ANALYTICS[REQUEST]);
    yield call(getCrmManagersAnalyticsSaga, search);
  }
}

export function* getCRMAnalyticsSaga({ date }) {
  try {
    const { status, data } = yield call(api.getCRMAnalytics, date);
    if (status < 300) {
      yield put(ActionTypes.getCRMAnalytics.success({ ...data }));
    } else {
      yield put(acceptError(data.detail, true));
      yield put(ActionTypes.getCRMAnalytics.failure());
    }
  } catch (e) {
    yield put(acceptError(e, true));
    yield put(ActionTypes.getCRMAnalytics.failure());
  }
}
export function* getCRMAnalyticsWatcherSaga() {
  while (true) {
    const { data } = yield take(ActionTypes.GET_CRM_ANALYTICS[REQUEST]);

    yield call(getCRMAnalyticsSaga, data);
  }
}

export default [
  fork(getCrmClientsAnalyticsWatcherSaga),
  fork(getCrmManagersAnalyticsWatcherSaga),
  fork(getCRMAnalyticsWatcherSaga),
];
